import { DestroyRef, inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { PageUtils } from '../common/page.utils';
import { getInitialAssessment, updateAssessmentSuccess } from '../store/actions/assessment.actions';
import { loadNextPage } from '../store/actions/page.actions';
import { AssessmentPageState, AssessmentState, PageContentState, PageState } from '../store/models/assessment-models';
import { selectAssessmentId, selectInitialAssessmentState } from '../store/selectors/assessment.selectors';

@Injectable({
  providedIn: 'root',
})
export class AssessmentService {
  private destroyRef = inject(DestroyRef);

  constructor(
    private pageStore: Store<PageState>,
    protected pageContentStore: Store<PageContentState>,
    private assessmentPageStore: Store<AssessmentPageState>,
    private assessmentStore: Store<AssessmentState>,
    private pageUtils: PageUtils,
  ) {}

  private initialAssessmentState = this.pageStore.select(selectInitialAssessmentState);

  public loadInitialAssessment(route: ActivatedRoute) {
    const routeParams = this.pageUtils.getRoutePathParameters(route.snapshot);
    const assessmentPageState = this.assessmentPageStore.select(selectAssessmentId);
    assessmentPageState.pipe(take(1)).subscribe((assessmentId) => {
      this.pageContentStore.dispatch(
        getInitialAssessment({
          orgId: routeParams.orgCode,
          campaignId: routeParams.campaignCode,
          assessmentId: assessmentId,
          invitationCode: routeParams.invitationCode,
        }),
      );
    });
  }

  public setInitialTestlet() {
    this.initialAssessmentState.pipe(take(1)).subscribe((initialAssessment) => {
      if (
        initialAssessment != null &&
        !initialAssessment.loading &&
        initialAssessment.error == null &&
        initialAssessment.data != null
      ) {
        this.pageStore.dispatch(loadNextPage({ nextPage: initialAssessment.data.nextTestlet }));
        this.assessmentStore.dispatch(
          updateAssessmentSuccess({
            testletConfig: {
              config: initialAssessment.data.config,
              nextTestlet: initialAssessment.data.nextTestlet,
              sessionId: initialAssessment.data.sessionId,
              assessmentId: initialAssessment.data.assessmentId,
            },
          }),
        );
      }
    });
  }
}
